// Copyright 2020 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
export const onboardingSteps = {
  ONBOARDING_START: 'onboarding-start',
  DEVICES_PENDING_ONBOARDING_START: 'devices-pending-onboarding-start',
  DASHBOARD_ONBOARDING_START: 'dashboard-onboarding-start',
  DASHBOARD_ONBOARDING_PENDINGS: 'dashboard-onboarding-pendings',
  DEVICES_DELAYED_ONBOARDING: 'devices-delayed-onboarding',
  DEVICES_PENDING_ONBOARDING: 'devices-pending-onboarding',
  DEVICES_ACCEPTED_ONBOARDING: 'devices-accepted-onboarding',
  DEVICES_PENDING_ACCEPTING_ONBOARDING: 'devices-pending-accepting-onboarding',
  DEVICES_DEPLOY_RELEASE_ONBOARDING: 'devices-deploy-release-onboarding',
  SCHEDULING_ARTIFACT_SELECTION: 'scheduling-artifact-selection',
  SCHEDULING_ALL_DEVICES_SELECTION: 'scheduling-all-devices-selection',
  SCHEDULING_GROUP_SELECTION: 'scheduling-group-selection',
  SCHEDULING_RELEASE_TO_DEVICES: 'scheduling-release-to-devices',
  DEPLOYMENTS_INPROGRESS: 'deployments-inprogress',
  DEPLOYMENTS_PAST: 'deployments-past',
  DEPLOYMENTS_PAST_COMPLETED: 'deployments-past-completed',
  DEPLOYMENTS_PAST_COMPLETED_FAILURE: 'deployments-past-completed-failure',
  ONBOARDING_CANCELED: 'onboarding-canceled'
};
export const SET_DEMO_ARTIFACT_PORT = 'SET_DEMO_ARTIFACT_PORT';
export const SET_ONBOARDING_COMPLETE = 'SET_ONBOARDING_COMPLETE';
export const SET_ONBOARDING_PROGRESS = 'SET_ONBOARDING_PROGRESS';
export const SET_ONBOARDING_DEVICE_TYPE = 'SET_ONBOARDING_DEVICE_TYPE';
export const SET_ONBOARDING_APPROACH = 'SET_ONBOARDING_APPROACH';
export const SET_SHOW_CREATE_ARTIFACT = 'SET_SHOW_CREATE_ARTIFACT';
export const SET_SHOW_ONBOARDING_HELP = 'SET_SHOW_ONBOARDING_HELP';
export const SET_SHOW_ONBOARDING_HELP_DIALOG = 'SET_SHOW_ONBOARDING_HELP_DIALOG';
export const SET_ONBOARDING_STATE = 'SET_ONBOARDING_STATE';
